<template>
  <div :style="{ minHeight: `${height}px` }">
    <iframe
      ref="iframe"
      sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
      allowfullscreen="true"
      :src="src"
      :style="{
        display: 'block',
        border: 'none',
        width: '100%',
        height: '100%',
        minHeight: `${height}px`
      }"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
export default {
  props: {
    intentId: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      height: 309,
      timestamp: String(dayjs().unix())
    }
  },
  computed: {
    ...mapGetters(['currentLang']),
    src() {
      if (!this.currentLang) return ''
      return `https://ananda.notification-center.enterprise.zwiz.app/${
        this.currentLang
      }/form/intent-notification-center?state=${this.isEdit ? 'edit' : 'preview'}&timestamp=${
        this.timestamp
      }`
    },
    notificationType() {
      return this.$route.name === 'conversation' ? 'inbox' : 'comment'
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      if (event.data.event_id === 'notification-center-intent-ready') {
        if (this.notificationType) {
          this.$refs.iframe.contentWindow.postMessage(
            {
              event_id: 'notification-center-intent-init',
              value: {
                type: this.notificationType,
                data: this.value,
                intent_id: this.intentId ? this.intentId : this.timestamp
              }
            },
            '*'
          )
        }
      } else if (event.data.event_id === 'notification-center-intent-set-height') {
        const { height, intent_id } = event.data.value
        if (![String(this.intentId), String(this.timestamp)].includes(String(intent_id))) return
        this.height = Number(height)
      } else if (event.data.event_id === 'notification-center-redirect-create') {
        this.$router.push('/' + this.currentLang + '/notification-center')
      } else if (event.data.event_id === 'notification-center-intent-submit') {
        const { groups, messages, intent_id } = event.data.value
        if (![String(this.intentId), String(this.timestamp)].includes(String(intent_id))) return
        const groupList = groups.map((item) => item.value)
        const messageList = messages.filter((item) => !!item.text)
        let payload = {}
        if (groupList.length > 0) {
          payload.notification_center_group_ids = groupList
        } else {
          payload.notification_center_group_ids = null
        }

        if (messageList.length > 0) {
          payload.notification_center_message = messageList
        } else {
          payload.notification_center_message = null
        }

        if (Object.keys(payload).length > 0) {
          this.$emit('onChangeNotificationCenter', payload)
        }
      } else if (event.data.event_id === 'open_external_link') {
        window.open(event.data.url, '_blank')
      } else if (event.data.event_id === 'copy_to_clipboard') {
        if (event.data.value) navigator.clipboard.writeText(event.data.value)
      } else if (event.data.event_id === 'open_link') {
        window.open(event.data.url, '_self')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/NotificationCenter/NotificationCenterIntent.vue